<template>
    <v-form ref="form" v-model="formValid" @input="handleFormInput" class="birthday-selector">
        <v-menu
                v-model="birthdayMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        :disabled="disabled"
                        ref="birthday"
                        class="form-item"
                        :value="reformatDate(innerBirthdayWithNoData)"
                        :rules="birthdayRules"
                        :label="label"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker
                    ref="picker"
                    v-model="innerBirthday"
                    :max="maxDate"
                    :min="minDate"
                    :pickerDate.sync="pickerDate"
                    @change="handleChangeBirthday"
                    first-day-of-week="1"
            >
                <div v-if="!$refs['picker'] || $refs['picker'].activePicker === 'YEAR'" style="width: 100%">
                    <v-btn block color="primary" @click="handleClickBirthdayNoData">No data</v-btn>
                </div>
                <div v-if="$refs['picker'] && $refs['picker'].activePicker === 'MONTH'" style="width:100%">
                    <v-btn block color="primary" @click="handleSelectOnlyYear($refs['picker'].tableYear)">Select
                        {{$refs['picker'].tableYear}} year
                    </v-btn>
                </div>
            </v-date-picker>
        </v-menu>
    </v-form>
</template>

<script>

    import {reformatDate} from '../../helpers/timeformats'
    import _ from "lodash";

    const defaultDateFormat = 'YYYY-MM-DD'

    export default {
        name: 'SimpleBirthdaySelector',
        props: {
            disabled: Boolean,
            birthday: String,
            noDataEnabled: Boolean,
            minDate: {
                type: String,
                default: '1900-01-01'
            },
            maxDate: {
                type: String,
                default: new Date().toISOString().substr(0, 10)
            },
            defaultDate: {
                type: String,
                default: '1980-01'
            },
            label: {
                type: String,
                default: 'Birthday'
            }
        },
        data() {
            return {
                formValid: false,
                innerBirthday: this.birthday,
                pickerDate: this.defaultDate,
                birthdayMenu: false,
                birthdayRules: [
                    function (v) {
                        if (v === null) {
                            return 'Select birthday'
                        }

                        return true
                    }
                ],
            }
        },
        watch: {
            birthdayMenu(val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            innerBirthday() {
                this.emitInput()
            },
            birthday(newValue) {
                if (newValue === null) {
                    this.innerBirthday = ''
                    return
                }

                this.innerBirthday = newValue
            },
        },
        computed: {
            innerBirthdayWithNoData: {
                get() {
                    if (this.innerBirthday === '' || (this.innerBirthday === null && this.noDataEnabled)) {
                        return 'No Data'
                    }

                    return this.innerBirthday
                },
                set(value) {
                    this.innerBirthday = value
                }
            },
        },
        methods: {
            handleSelectOnlyYear(year) {
                this.innerBirthdayWithNoData = `${year}-01-01`
                this.birthdayMenu = false
            },
            handleChangeBirthday(value) {
                this.birthdayMenu = false
            },
            handleClickBirthdayNoData() {
                this.innerBirthdayWithNoData = ''
                this.birthdayMenu = false
            },
            prepareResult() {
                return this.innerBirthday === '' ? null : this.innerBirthday
            },
            emitInput: _.debounce(function () {
                this.$emit('input', this.prepareResult())
            }, 100),
            handleFormInput(value) {
                this.$emit('validation-changed', value)
            },
            reformatDate: reformatDate,
            isValid() {
                return this.formValid
            },
            validate() {
                return this.$refs['form'].validate()
            },
        }
    }
</script>

<style scoped>

</style>